/* Package JSON Import will be here */
import React from "react";
import { Empty } from 'antd';
/* Package JSON Import will be here */

const NoData = props => {
    return (
        <Empty description={props.NoDataMessage} image={Empty.PRESENTED_IMAGE_SIMPLE} />
    );
};

export default NoData;
